import { Button, ButtonSizes, ButtonVariants } from '@inno-ui/button'
import {
  ArrowCirclePathRightIcon,
  ExclamationCircleLineIcon,
  IconSizes
} from '@inno-ui/icons'
import { AuthLanguageSelector } from 'modules/auth/templates/AuthPageTemplate/AuthLanguageSelector'
import { I18nextProvider, useTranslation } from 'react-i18next'
import { PublicFooter } from 'shared/components/PublicFooter/PublicFooter'
import { i18nextContainer } from 'shared/configs/i18n/config'

import styles from './GlobalErrorPage.module.scss'
import loginBackground from '/public/auth-module/login-bg.webp'
import clusterixLogoWhite from '/public/clusterix-logo-white.svg'

// This fallback sits outside App's providers, so it must render independently.
export const GlobalErrorPage = () => (
  <I18nextProvider i18n={i18nextContainer}>
    <GlobalErrorPageContent />
  </I18nextProvider>
)

const GlobalErrorPageContent = () => {
  const { t, i18n } = useTranslation('translation', {
    keyPrefix: 'errors.GLOBAL_ERROR'
  })

  return (
    <div
      className={styles.page}
      lang={i18n.resolvedLanguage || i18n.language}
      style={{ backgroundImage: `url(${loginBackground})` }}
    >
      <header className={styles.header}>
        <img
          className={styles.logo}
          src={clusterixLogoWhite}
          alt='Clusterix'
          width={246}
          height={67}
        />
        <div className={styles.languageSelector}>
          <AuthLanguageSelector inline />
        </div>
      </header>

      <main className={styles.main}>
        <section className={styles.card} aria-labelledby='global-error-title'>
          <div className={styles.icon} aria-hidden='true'>
            <ExclamationCircleLineIcon size={IconSizes.Size48} color='#fff' />
          </div>
          <div className={styles.message} role='alert'>
            <h1 id='global-error-title' className={styles.title}>
              {t('title')}
            </h1>
            <p className={styles.description}>{t('description')}</p>
          </div>
          <div>
            <Button
              type='button'
              label={t('reload_button')}
              icon={ArrowCirclePathRightIcon}
              size={ButtonSizes.M}
              variant={ButtonVariants.Dark}
              onClick={() => window.location.reload()}
            />
          </div>
          <p className={styles.hint}>{t('hint')}</p>
        </section>
      </main>

      <div className={styles.footer}>
        <PublicFooter />
      </div>
    </div>
  )
}
